import {
    LOG_OUT, KPI_PLANNING_CATEGORIES, DESTINATION_ITEMS, HABITS_ITEMS, 
    JOB_KPIS, JOB_LIST, ALL_KPI_LIST, ALL_JOB_KPIS
} from "./ActionTypes";

import KPIPlanningService from "../services/KPIPlanningService";
import {getUser} from "../utils/TokenManager";
import {DESTINATION_INDEX} from "../components/kpiPlanning/constants";


const logOutSuccess = () => ({type: LOG_OUT});
const setCategories = (categories) => ({type: KPI_PLANNING_CATEGORIES, categories});
const setDestinationItems = (destinationItems) => ({type: DESTINATION_ITEMS, destinationItems});
const setHabitItems = (habitItems) => ({type: HABITS_ITEMS, habitItems});
const setJobKPIList = (kpiList) => ({type: JOB_KPIS, kpiList});
const setAllJobKPIList = (kpiList) => ({type: ALL_JOB_KPIS, kpiList});
const setKPIList = (allKPIData) => ({type: ALL_KPI_LIST, allKPIData});
const setJobList = (jobList) => ({type: JOB_LIST, jobList});


export const getKPIPlanningCategories = () => (
    async (dispatch) => {
        try {
            let result = await KPIPlanningService.getKPIPlanningCategories();

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                dispatch(setCategories(result.data));
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getDestinations = (locationId) => (
    async (dispatch) => {
        try {
            let result = await KPIPlanningService.getDestinations(locationId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                dispatch(setDestinationItems(result.data));
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getHabits = (jobTitleId) => (
    async (dispatch) => {
        try {
            let result = await KPIPlanningService.getHabits(jobTitleId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                dispatch(setHabitItems(result.data));
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getJobKPIs = (jobTitleId) => (
    async (dispatch) => {
        try {
            let result = await KPIPlanningService.getJobKPIs(jobTitleId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                dispatch(setJobKPIList(result.data));
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getAllJobKPIs = (locationId) => (
    async(dispatch) => {
        try {
            let result = await KPIPlanningService.getAllJobKPIs(locationId);
    
            if (200 === result.status) {
                dispatch(setAllJobKPIList(result.data));
                return true
            }
        } catch (error) {
            if (401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const unsetHabits = () => (
    async (dispatch) => {
        try {
            dispatch(setHabitItems([]));
            return true;
        } catch (error) {
           console.log(error);
        }
        return false;
    }
);


export const unsetKPIs = () => (
    async (dispatch) => {
        try {
            dispatch(setJobKPIList([]));
            return true;
        } catch (error) {
           console.log(error);
        }
        return false;
    }
);


// Compare Item for sorting
const compareItem = (a, b) => {
    if (a.item.toUpperCase() < b.item.toUpperCase()) {
        return -1;
    }
    if (a.item.toUpperCase() > b.item.toUpperCase()) {
        return 1;
    }
    return 0;
};

export const addEditItem = (kpiPlanningItem, KPIPlanningItemList, type) => (
    async (dispatch) => {
        try {
            let result = {};
            if (kpiPlanningItem.id) {
                result = await KPIPlanningService.updateKPIPlanningItem(kpiPlanningItem, type);
            } else {
                result = await KPIPlanningService.addKPIPlanningItem(kpiPlanningItem, type);
            }

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            let updatedList = [];
            if (200 === result.status) {
                // Type 0: Destination, 1: habit
                updatedList = KPIPlanningItemList.map(item => {
                    if (item.id === result.data.id) {
                        return {...result.data};
                    } else {
                        return {...item};
                    }
                });
            } else if (201 === result.status) {
                updatedList = [...KPIPlanningItemList, result.data];
            }
            updatedList.sort(compareItem);
            if (type === DESTINATION_INDEX) {
                dispatch(setDestinationItems(updatedList));
                return result.data;
            } else {
                dispatch(setHabitItems(updatedList));
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const updatetable = (kpiPlanningItem, KPIPlanningItemList, type) => (
    async (dispatch) => {
        try {
            if (kpiPlanningItem.id) {
                // updated item list in redux store
                let updatedList = KPIPlanningItemList.map(item => {
                    if (item.id === kpiPlanningItem.id) {
                        return {...kpiPlanningItem};
                    } else {
                        return {...item};
                    }
                });
                if (type === DESTINATION_INDEX) {
                    dispatch(setDestinationItems(updatedList));
                } else {
                    dispatch(setHabitItems(updatedList));
                }

                // Update database
                let result = await KPIPlanningService.updateKPIPlanningItem(kpiPlanningItem, type);

                if (getUser()['app-version'] !== result.headers['app-version']) {
                    dispatch(logOutSuccess());
                }
                if (200 === result.status) {
                    return true;
                }
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);


export const deleteItem = (itemId, KPIPlanningItemList, type) => (
    async (dispatch) => {
        try {
            let result = await KPIPlanningService.deleteKPIPlanningItem(itemId, type);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                let updatedList = KPIPlanningItemList.filter(item => item.id !== itemId)
                // Type 0: Destination, 1: habit
                if (type === DESTINATION_INDEX) {
                    dispatch(setDestinationItems(updatedList));
                } else {
                    dispatch(setHabitItems(updatedList));
                }
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getAllKPIs = (locationId) => (
    async(dispatch) => {
        try {
            let result = await KPIPlanningService.getKPIList(locationId);
    
            if (200 === result.status) {
                dispatch(setKPIList(result.data));
                return true
            }
        } catch (error) {
            if (401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getJobTitles = (locationId) => (
    async(dispatch) => {
        try {
            let result = await KPIPlanningService.jobTitleList(locationId);
    
            if (200 === result.status) {
                dispatch(setJobList(result.data.job_title));
                return true
            }
        } catch (error) {
            if (401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const updateKPIinTable = (jobKPI, jobKPIs, type) => (
    async (dispatch) => {
        try {
            let result = {}, updatedJobKPIList = [];
            if (jobKPI.id) {
                // update props
                updatedJobKPIList = jobKPIs.map(item => {
                    if (item.id === jobKPI.id) {
                        return {...jobKPI};
                    } else {
                        return {...item};
                    }
                });
                dispatch(setJobKPIList(updatedJobKPIList));

                // call update kpi service
                result = await KPIPlanningService.updateKPIPlanningItem(jobKPI, type);
            } else {
                // call add kpi service
                result = await KPIPlanningService.addKPIPlanningItem(jobKPI, type);
            }

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                return true;
            } else if (201 === result.status) {
                updatedJobKPIList = [...jobKPIs, result.data];
                dispatch(setJobKPIList(updatedJobKPIList))
            }
            
        } catch (error) {
            // reset props if any errors occured
            dispatch(setJobKPIList(jobKPIs));

            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const deleteKPIinTable = (itemId, jobKPIs, type) => (
    async (dispatch) => {
        try {
            let result = await KPIPlanningService.deleteKPIPlanningItem(itemId, type);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                let updatedJobKPIList = jobKPIs.filter(item => item.id !== itemId);
                dispatch(setJobKPIList(updatedJobKPIList));
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);



// WEBPACK FOOTER //
// ./src/actions/KPIPlanningAction.js